/** URL do formulário do colaborador (link que o RH distribui). */
export function companyFormularioPath(companyId: string): string {
	return `/empresa/formulario/${companyId}`;
}

const UUID_RE =
	/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isCompanyFormularioCompanyId(
	value: string | undefined,
): value is string {
	return !!value && UUID_RE.test(value);
}

export function parseCompanyFormularioCompanyId(
	value: string | undefined,
): string | null {
	return isCompanyFormularioCompanyId(value) ? value : null;
}
